import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Settings2 } from 'lucide-react';
import type { OrderColumnKey } from '../types';

const ALL_COLUMNS: { key: OrderColumnKey; labelKey: string }[] = [
  { key: 'quoteNumber', labelKey: 'table.orderNumber' },
  { key: 'status', labelKey: 'table.status' },
  { key: 'createdAt', labelKey: 'table.created' },
  { key: 'acceptedDate', labelKey: 'table.accepted' },
  { key: 'accountName', labelKey: 'table.customer' },
  { key: 'projectName', labelKey: 'table.project' },
  { key: 'salesManager', labelKey: 'table.salesManager' },
  { key: 'contractualManager', labelKey: 'table.contact' },
  { key: 'total', labelKey: 'table.total' },
  { key: 'expirationDate', labelKey: 'table.expiration' },
  { key: 'poNumber', labelKey: 'table.poNumber' },
];

interface OrderColumnVisibilityToggleProps {
  visibleColumns: Record<OrderColumnKey, boolean>;
  onToggle: (key: OrderColumnKey) => void;
}

export function OrderColumnVisibilityToggle({
  visibleColumns,
  onToggle,
}: OrderColumnVisibilityToggleProps) {
  const { t } = useTranslation('orders');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Settings2 className="h-4 w-4 mr-1" />
          {t('table.columns')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('table.toggleColumns')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ALL_COLUMNS.map((col) => (
          <DropdownMenuCheckboxItem
            key={col.key}
            checked={visibleColumns[col.key] !== false}
            onCheckedChange={() => onToggle(col.key)}
            disabled={col.key === 'quoteNumber'}
          >
            {t(col.labelKey)}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
